export default __webpack_public_path__ + "static/media/Group 2021.545109ae.svg";